import { useMemo, useState } from "react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Search } from "../ui/search";

const CitySelect = ({
  value,
  onChange,
  citiesOption
}: {
  value: {id: string; name_city: string; office_id: string};
  onChange: (val: {id: string; name_city: string; office_id: string}) => void;
  citiesOption: any[];
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const handleChange = (val: string) => {
    if (!val) return;
    const selectedCity = citiesOption.find(
      (city: any) => String(city.id) === String(val)
    );

    if (!selectedCity) return;

    onChange({
      id: String(selectedCity.id),
      name_city: selectedCity.name_city,
      office_id: String(selectedCity.office_id)
    });
  };

  const filteredCities = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    return (citiesOption || []).filter((city: any) =>
      String(city?.name_city || "").toLowerCase().includes(q)
    );
  }, [citiesOption, searchQuery]);

  return (
    <div className="r-form-field-item-container">
       <h3 className='mb-2 text-[16px]  font-semibold text-center sm:text-left md:text-lg'>Miasto</h3>
    <Select
      name='selected_city_id'
      value={value?.id || ''}
      onValueChange={handleChange}
    >
      <SelectTrigger
        className={`w-full h-[50px] text-base  ${
          value?.id
            ? 'text-text-primary font-semibold'
            : 'text-[#888888] font-normal'
        }`}
      >
        <SelectValue placeholder={<span>Wybierz miasto</span>} />
      </SelectTrigger>

      <SelectContent>
        <div className='px-3 pt-3 pb-1'>
          <Search
            placeholder='Wyszukaj miasto'
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className='h-11'
          />
        </div>
        <SelectGroup>
          {filteredCities.map((city: any) => (
            <SelectItem
              // className='text-base font-normal text-[#888888] focus:text-[var(--text-primary)]'
              key={city.id}
              value={String(city.id)}
              data-office-id={city.office_id}
            >
              <span>{city.name_city}</span>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
    </div>
  );
};

export default CitySelect;